import React, { useState, useEffect } from "react";
import { Collapse } from "antd";
import Api from "../../../../services/ServiceApi";
const { Panel } = Collapse;

const AssetDetailPanel = ( {data}) => {
  // const [assetDetailData, setAssetDetailData] = useState({});
  function isNull(data) {
    return data === null ? "-" : data;
  }

  return (
    <Collapse expandIconPosition="right" defaultActiveKey={["1"]}>
      <Panel
        header={
          <div>
            <img
              src={Api.absoluteUrl("/icon/asset_detail.svg")}
              className="mr-3"
              alt="asset detail icon"
            />
            <span className="c-blue text-uppercase">
              <span className="c-blue text-uppercase">Asset Detail</span>
            </span>
          </div>
        }
        key="1"
      >
        <div className="">
          <img
            src={Api.absoluteUrl("/img/img_job.png")}
            className="img-fluid"
          />
        </div>
        <div className="card-stat" style={{ display: "flex" }}>
          {/* bus NO */}
          <div className="col-4 text-center">
            <span>Bus No.</span>
            <h4 className="fs-34">{isNull(data.busNO)}</h4>
          </div>
          {/* line NO */}
          <div className="col-4 text-center">
            <span>Line No.</span>
            <h4 className="fs-34">{isNull(data.lineNO)}</h4>
          </div>
          {/* Plate O */}
          <div className="col-4 text-center">
            <span>Plate No.</span>
            <h4 className="fs-34">{isNull(data.plateNO)}</h4>
          </div>
        </div>
      </Panel>
    </Collapse>
  );
};

export default AssetDetailPanel;
